import React, { useCallback, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { expandedLeaderboardStyles as styles } from "./ExpandedLeaderboard.tailwind.js";
import { connect, useSelector } from "react-redux";
import BottomPagination from "../../Pagination/BottomPagination/BottomPagination.jsx";
import no_leaderboard from "../../../../assets/svgs/no_leaderboard_details.svg"
import collapse_leaderboard from "../../../../assets/svgs/collapse_leaderboard.svg"
import { getAllLeaderboardDetails } from "../../../../redux/slices/liveGameSlice.js";
import { Refresh } from "@mui/icons-material";
import PlayerCard from "./PlayerCard.jsx";
// import Button from "../../Button/Button";

const ExpandedLeaderboardModal = ({ isOpen, onClose, getFullLeaderboard, gameId, isFullScreened }) => {
  const { fullGameLeaderboardDetails, fullLeaderboardLoading} = useSelector(state => state.liveGame);
  const leaderboardData = fullGameLeaderboardDetails?.leaderboard || [];

  const handlePageChange = (e, value) => {
    console.log(value);

    const data = {
      gameId: gameId,
      limit: "50",
      page: value?.toString()
    }

    getFullLeaderboard(data)
  }

  const reloadLeaderboard = useCallback(() => {
    const data = {
      gameId: gameId,
      limit: "50",
    }

    getFullLeaderboard(data)
  }, [gameId]);

  useEffect(() => {
    reloadLeaderboard()
  }, [reloadLeaderboard]);
  
  return (
    <Modal open={isOpen} disableAutoFocus disableEnforceFocus onClose={onClose}>
      <div className={`${styles.container} ${isFullScreened ? "rotate-90 !max-h-[90vw] !min-w-[500px]" : ""}`}>
        <div className="bg-liveGamePrimaryColor w-full relative py-2 px-4">
          <h1 className="w-full text-left text-[16px]">
            Game Leaderboard
          </h1>

          <div className="absolute top-1/2 -translate-y-1/2 right-2 flex items-center gap-2">
            {/* Reload Button */}
            <button onClick={reloadLeaderboard} disabled={fullLeaderboardLoading}>
              <Refresh className={`${fullLeaderboardLoading ? 'animate-spin' : ''}`} />
            </button>
            {/* Close Button */}
            <button onClick={onClose}>
              <img src={collapse_leaderboard} alt="" className="max-w-[20px]" />
            </button>
          </div>
        </div>

        {fullLeaderboardLoading ? (
          <div className={styles.table_wrapper}>
            <div className={styles.top_players}>
              {/* 2nd Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[70px] !h-[70px] screen-430:!w-[85px] screen-430:!h-[85px]`}
                details={null}
                skeleton={true}
              />

              {/* 1st Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[80px] !h-[80px] screen-430:!w-[105px] screen-430:!h-[105px]`}
                details={null}
                skeleton={true}
              />

              {/* 3rd Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[70px] !h-[70px] screen-430:!w-[85px] screen-430:!h-[85px]`}
                details={null}
                skeleton={true}
              />
            </div>
            {/* <LeaderBoardSkeleton count={3} /> */}

            {/* <div className={styles.leaderboard_wrapper}>
              {Array(3).fill(0, 0)?.map((ele, key) => (
                <div className={styles.dataRow} key={key} />
              ))}
            </div> */}
          </div>
        ) : !leaderboardData || leaderboardData?.length === 0 ? (
          <div className='flex flex-col items-center justify-center h-full pb-2 gap-1 screen-500:h-[unset] justify-[unset] py-5'>
            <img src={no_leaderboard} alt="" className={styles.no_leaderboard} />
            <p className={styles.no_leaderboard_text}>No Points are awarded yet.</p>
          </div>
        ): (
          <div className={styles.table_wrapper}>
            {fullGameLeaderboardDetails?.userScoreAndRank && (
              <div className={styles.top_summary_header}>
                <p className={styles.header_text}>I Have:
                  <span className={styles.highlighted_header_text}>
                    {fullGameLeaderboardDetails?.userScoreAndRank?.tokenPoints} Points
                  </span>
                </p>

                <p className={styles.header_text}>My Place:
                  <span className={styles.highlighted_header_text}>
                    {fullGameLeaderboardDetails?.userScoreAndRank?.rank}
                  </span>
                </p>
              </div>
            )}

            {/* Top Players */}
            <div className={styles.top_players}>
              {/* 2nd Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[70px] !h-[70px] screen-430:!w-[85px] screen-430:!h-[85px]`}
                details={leaderboardData?.length >= 2 ? leaderboardData[1] : null}
              />

              {/* 1st Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[80px] !h-[80px] screen-430:!w-[105px] screen-430:!h-[105px]`}
                details={leaderboardData?.length >= 1 ? leaderboardData[0] : null}
              />

              {/* 3rd Card */}
              <PlayerCard
                innerImageWrapperClassName={`!w-[70px] !h-[70px] screen-430:!w-[85px] screen-430:!h-[85px]`}
                details={leaderboardData?.length >= 3 ? leaderboardData[2] : null}
              />
            </div>

            <div className={`${styles.leaderboard_wrapper} ${isFullScreened ? '!grid-cols-6' : ''}`}>
                {leaderboardData?.slice(3)?.map((leaderboard, key) => (
                  <PlayerCard
                    key={key}
                    details={leaderboard}
                  />
                ))}
            </div>

            {/* Pagination */}
            {fullGameLeaderboardDetails?.pagePages > 1 && (
              <BottomPagination totalPages={fullGameLeaderboardDetails?.pagePages} currentPage={fullGameLeaderboardDetails?.pageNumber} onPageChange={handlePageChange} />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getFullLeaderboard: (data) => dispatch(getAllLeaderboardDetails(data))
})

export default connect(null, mapDispatchToProps)(ExpandedLeaderboardModal);